/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagetypestitle3Inputs */

const en_ticketpagetypestitle3 = /** @type {(inputs: Ticketpagetypestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By ticket type`)
};

const de_ticketpagetypestitle3 = /** @type {(inputs: Ticketpagetypestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Ticketart`)
};

/**
* | output |
* | --- |
* | "By ticket type" |
*
* @param {Ticketpagetypestitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagetypestitle3 = /** @type {((inputs?: Ticketpagetypestitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagetypestitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagetypestitle3(inputs)
	return de_ticketpagetypestitle3(inputs)
});
export { ticketpagetypestitle3 as "ticketPageTypesTitle" }